const getSetting = function(setting) {
    const subKeys = setting.split('.');
    let result = appKitSettings;

    for (let i = 0; i < subKeys.length; i++) {
        const element = subKeys[i];
        if (result[element] !== undefined) {
            result = result[element];
        }
        else {
            result = null;
            break;
        }
    }
    return result;
}

export const settingsPlugin = {
    install: (Vue) => {
        Vue.prototype.$getSetting = (key) => getSetting(key);
        Vue.prototype.$assetUrl = () => getSetting('paths.assets');
        Vue.prototype.$appKitUrl = () => getSetting('paths.baseAppKit');
    }
}
